import React, {Component} from 'react';
import {Button, Checkbox, InputGroup, Popover, Position} from "@blueprintjs/core";
import { AutoSizer, List } from 'react-virtualized';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import { Spinner } from "@blueprintjs/core";
import { filter } from '../../../utils/filter';

import { toggleEditor, insertRecord, setFilter, removeFilters, search } from "../../../store/contractors/actions";

const FUSE_OPTIONS = {
  threshold: 0.2,
  maxPatternLength: 32,
  minMatchCharLength: 2,
  keys: [
    {name: 'full_name', weight: 0.2},
    {name: 'first_name', weight: 0.2},
    {name: 'last_name', weight: 0.2},
    {name: 'pps_number', weight: 0.2},
    {name: 'crew_code', weight: 0.2},
    {name: 'company', weight: 0.2},
  ]
};

class DataList extends Component {
  constructor(props){
    super(props);
    this._rowRenderer = this._rowRenderer.bind(this);
    this._setRef = this._setRef.bind(this);

    this.state = {
      records: [],
      selectedId: null,
      filters: {
        crew_code: this.props.filters.some(filter => filter.name === 'crew_code'),
        pps_number: this.props.filters.some(filter => filter.name === 'pps_number'),
      }
    }
  }

  componentDidMount() {
    if (this.props.records.length) {
      const { filters, searchPhrase, records } = this.props;
      const filteredData = filter(records, filters, searchPhrase, FUSE_OPTIONS);
      console.log(filteredData);
      
      const sortedRecords = this.props.records.sort((a, b) => a.full_name ? a.full_name.localeCompare(b.full_name) : 0);
      this.setState({
        records: sortedRecords
      });
    }
  }
  
  componentWillReceiveProps(nextProps, nextContext) {
    if (!nextProps.loading){
      const { filters, searchPhrase, records, match } = nextProps;
      filter(records, filters, searchPhrase, FUSE_OPTIONS).then(data => {
        const sortedRecords = data.sort((a, b) => a.full_name ? a.full_name.localeCompare(b.full_name) : 0);
        let selectedIndex = 0;
        data.map((element, index) => {
          if (element && parseInt(element.id) == parseInt(match.params._id)) {
            selectedIndex = index + 2;
          }
          return element;
        });
        //const selectedIndex = data.filter(element =>{console.log(element.id)});
        this.setState({
          records: sortedRecords,
          selectedId: match.params._id,
          selectedIndex
        }, () => {
          this.list.forceUpdateGrid();
        });
      });
    }
  }

  handleFilter(name, operator, value) {

    const newFilters = this.state.filters;
    newFilters[name] = value;

    this.setState({
      filters: newFilters,
    });
    this.props.setFilter(name, operator, value);
  }

  handleFilterClear() {
    this.handleFilter('crew_code', 'isEmpty', false);
    this.handleFilter('pps_number', 'isEmpty', false);
  }

  render() {
    const { loading, filters, search, searchPhrase }  = this.props;
    return (
      <div className="left relative">
        <div className="absolute flex column">
          {!loading ? (
            <React.Fragment>
              <div className="tools">
                <Button large onClick={() => this.props.toggleEditor({})} icon="add" intent="success" text="Add New" />
              </div>
              <div className="tools">
                <InputGroup
                  leftIcon="search"
                  onChange={(e) => {search(e.currentTarget.value)}}
                  name="vat_number"
                  id="vat_number"
                  large
                  placeholder="Search"
                  defaultValue={searchPhrase}
                />
                <Popover popoverClassName="blue" content={
                  <div className="filters">
                    <div className="grid">
                      <Checkbox onChange={(el) => this.handleFilter('crew_code', 'isEmpty', el.currentTarget.checked)} inline large checked={this.state.filters.crew_code}>No CREW Code</Checkbox>
                      <Checkbox onChange={(el) => this.handleFilter('pps_number', 'isEmpty', el.currentTarget.checked)} inline large checked={this.state.filters.pps_number}>No PPS Number</Checkbox>
                    </div>
                    <div className="footer">
                      <Button text="Clear" intent="primary" onClick={() => this.handleFilterClear()}/>
                    </div>
                  </div>
                } position={Position.BOTTOM}>
                  <Button className={Object.keys(filters).length && 'has-filters'} style={{marginLeft: '5px'}} large icon="filter-list" text="Filter">{Object.keys(filters).length > 0 && <div className="badge">{Object.keys(filters).length}</div>}</Button>
                </Popover>
              </div>
              <div className="stretch">
                <AutoSizer>
                  {({width, height}) => (
                    <div>
                      <List
                        className="list"
                        ref={(list) => {
                          this.list = list
                        }}
                        scrollToIndex={this.state.selectedIndex}
                        height={height}
                        rowCount={this.state.records.length}
                        rowHeight={120}
                        rowRenderer={this._rowRenderer}
                        width={width}
                      />
                    </div>
                  )}
                </AutoSizer>
              </div>
            </React.Fragment>
            ) : (<Spinner className="mt50" />)}
        </div>
      </div>
    );
  }

  _rowRenderer({index, isScrolling, key, style}) {
    const {showScrollingPlaceholder} = this.state;
    const record = this.state.records[index];
    if (showScrollingPlaceholder && isScrolling) {
      return (
        <div
          key={key}
          style={style}>
          Scrolling...
        </div>
      );
    }

    const cn = "row-wrapper" + ( record && parseInt(this.props.match.params._id) == record.id ? ' selected' : '');
    const subView = this.props.match.params._view ? `/${this.props.match.params._view}` : '';

    const companyName = record && record.company ? typeof record.company === 'string'  ? record.company : record.company.name : '';

    return (
      <div className={cn} key={key} style={style} onClick={() => this.props.onSelect && this.props.onSelect()}>
        { record && 
          <Link to={`/contractors/${record.id}${subView}`} className="row">
            <h3>{record.first_name} {record.last_name}</h3>
            <div className="body">
              <div><span><i className="divider blue1"/>PPS Number: </span><b>{record.pps_number}</b></div>
              <div><span><i className="divider blue2"/>CREW Number: </span><b>{record.crew_code}</b></div>
              <h4>{companyName}</h4>
            </div>
          </Link>
        }
      </div>
    );
  }

  _setRef (ref) {
    this.list = ref;
  }
}

function matchDispatchToProps(dispatch){
  return bindActionCreators({
    toggleEditor,
    insertRecord,
    setFilter,
    removeFilters,
    search
  }, dispatch);
}

function mapStateToProps(state){
  if (state.socket && state.socket.event === "TOAST"){
    return {
      toast: state.socket.data,
    }
  }

  return {
    filters: state.contractors.filters,
    searchPhrase: state.contractors.searchPhrase,
    loading: state.contractors.loading,
    records: state.contractors.records,
    selectedRecord: state.contractors.selectedRecord,
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(withRouter(DataList));
